export const STORAGE_KEY = 'badge_date_seen';

export const DATA_REFRESH_INTERVAL = 30000; // 30 seconds
